import React, { useState, useEffect } from 'react';
import AppSidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

// Appwrite imports
import { Client, Databases, Storage, Query } from 'appwrite';

// Initialize Appwrite client
const client = new Client();
client
  .setEndpoint('https://cloud.appwrite.io/v1')
  .setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const MyPoems = () => {
  const [poems, setPoems] = useState([]);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchPoems = async () => {
      try {
        if (!currentUser) return;

        const response = await databases.listDocuments(DATABASE_ID, COLLECTION_ID, [
          Query.equal('userId', currentUser.uid),
          Query.equal('contentType', 'Poem'),
        ]);

        const poemsData = response.documents.filter(
          (doc) => doc.userId === currentUser.uid
        );

        setPoems(poemsData);

      } catch (error) {
        console.error('Error fetching poems:', error);
      }
    };

    fetchPoems();
  }, [currentUser]);

  // Fixed getImageUrl function to use the correct Appwrite SDK method
  const getImageUrl = (imageId) => {
    if (!imageId) return null;
    try {
      // Use the correct method to get file view directly instead of preview
      return storage.getFileView(BUCKET_ID, imageId);
    } catch (error) {
      console.error('Error generating image URL:', error);
      return '';
    }
  };

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex">
      <div className='sticky top-0 h-screen'>
        <AppSidebar user={currentUser} />
      </div>
      <div className="ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen">
        <h1 className="text-2xl font-bold mb-4">My Poems</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {poems.length > 0 ? (
            poems.map((poem) => (
              <div key={poem.$id} className="bg-white rounded-lg shadow-md overflow-hidden">
                {poem.imageId && (
                  <div className="h-48 w-full">
                    <img
                      src={getImageUrl(poem.imageId)}
                      alt={poem.title}
                      className="h-full w-full object-cover"
                      onError={(e) => {
                        console.error('Image failed to load:', poem.imageId);
                        e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Found';
                      }}
                    />
                  </div>
                )}
                <div className="p-4">
                  <h2 className="text-xl font-bold mb-2">{poem.title}</h2>

                  {/* Category Badge */}
                  {poem.category && (
                    <div className="mb-2">
                      <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {poem.category}
                      </span>
                    </div>
                  )}

                  {/* Approval Status */}
                  <div className="mb-2">
                    {poem.isApproved ? (
                      <span className="text-green-600 text-sm font-semibold">Approved ✅</span>
                    ) : (
                      <span className="text-red-500 text-sm font-semibold">Not Approved ❌</span>
                    )}
                  </div>

                  <p className="text-gray-700 whitespace-pre-line">{poem.content}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No poems found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyPoems;